import {chunk} from 'lodash';
import {HTMLAttributes, useState} from 'react';
import styled from 'styled-components';
import {Typography} from '@/components/Typography';
import {Flexbox} from '@/styled-components';
import {interceptProps} from '@/styled-components/utils';
import {palette} from '@/styles';
import Icon0101 from './assets/icon-legend-01-01.svg';
import Icon0102 from './assets/icon-legend-01-02.svg';
import Icon0103 from './assets/icon-legend-01-03.svg';
import Icon0104 from './assets/icon-legend-01-04.svg';
import Icon0105 from './assets/icon-legend-01-05.svg';
import Icon0106 from './assets/icon-legend-01-06.svg';
import Icon0107 from './assets/icon-legend-01-07.svg';
import Icon0108 from './assets/icon-legend-01-08.svg';
import Icon0109 from './assets/icon-legend-01-09.svg';
import Icon0110 from './assets/icon-legend-01-10.svg';
import Icon0201 from './assets/icon-legend-02-01.svg';
import Icon0202 from './assets/icon-legend-02-02.svg';
import Icon0203 from './assets/icon-legend-02-03.svg';
import Icon0204 from './assets/icon-legend-02-04.svg';
import Icon0205 from './assets/icon-legend-02-05.svg';
import Icon0206 from './assets/icon-legend-02-06.svg';
import Icon0207 from './assets/icon-legend-02-07.svg';
import Icon0208 from './assets/icon-legend-02-08.svg';
import Icon0209 from './assets/icon-legend-02-09.svg';
import Icon0210 from './assets/icon-legend-02-10.svg';
import Icon0301 from './assets/icon-legend-03-01.svg';
import Icon0302 from './assets/icon-legend-03-02.svg';
import Icon0303 from './assets/icon-legend-03-03.svg';
import Icon0304 from './assets/icon-legend-03-04.svg';
import Icon0305 from './assets/icon-legend-03-05.svg';
import Icon0306 from './assets/icon-legend-03-06.svg';
import Icon0307 from './assets/icon-legend-03-07.svg';
import Icon0308 from './assets/icon-legend-03-08.svg';
import Icon0309 from './assets/icon-legend-03-09.svg';
import Icon0310 from './assets/icon-legend-03-10.svg';
import Icon0401 from './assets/icon-legend-04-01.svg';
import Icon0402 from './assets/icon-legend-04-02.svg';
import Icon0403 from './assets/icon-legend-04-03.svg';
import Icon0404 from './assets/icon-legend-04-04.svg';
import Icon0405 from './assets/icon-legend-04-05.svg';
import Icon0406 from './assets/icon-legend-04-06.svg';
import Icon0407 from './assets/icon-legend-04-07.svg';
import Icon0408 from './assets/icon-legend-04-08.svg';
import Icon0409 from './assets/icon-legend-04-09.svg';
import Icon0410 from './assets/icon-legend-04-10.svg';
import Icon0501 from './assets/icon-legend-05-01.svg';
import Icon0502 from './assets/icon-legend-05-02.svg';
import Icon0503 from './assets/icon-legend-05-03.png';
import Icon0504 from './assets/icon-legend-05-04.svg';
import Icon0505 from './assets/icon-legend-05-05.png';
import Icon0506 from './assets/icon-legend-05-06.svg';
import Icon0507 from './assets/icon-legend-05-07.svg';
import Icon0508 from './assets/icon-legend-05-08.svg';
import Icon0509 from './assets/icon-legend-05-09.svg';
import Icon0510 from './assets/icon-legend-05-10.svg';

interface IProps extends HTMLAttributes<HTMLDivElement> {
  onClose?(e?: any): void;
}

interface ITab {
  id: string;
  content: Array<{
    icon?: string;
    label?: string;
  }>;
}

const TABS: ITab[] = [
  {
    id: '지번·경계',
    content: [
      {icon: Icon0101, label: '대표지번'},
      {icon: Icon0102, label: '지번'},
      {icon: Icon0103, label: '독립지번'},
      {icon: Icon0104, label: '지적경계'},
      {icon: Icon0105, label: '시도경계'},
      {icon: Icon0106, label: '시군구경계'},
      {icon: Icon0107, label: '행정동경계'},
      {icon: Icon0108, label: '법정동경계'},
      {icon: Icon0109, label: '읍면경계'},
      {icon: Icon0110, label: '리경계'},
    ],
  },
  {
    id: '개발',
    content: [
      {icon: Icon0201, label: '택지개발지구'},
      {icon: Icon0202, label: '신도시'},
      {icon: Icon0203, label: '정비구역'},
      {icon: Icon0204, label: '보금자리개발지구'},
      {icon: Icon0205, label: '뉴타운지구'},
      {icon: Icon0206, label: '도시개발구역'},
      {icon: Icon0207, label: '경제자유구역'},
      {icon: Icon0208, label: '재개발지역'},
      {icon: Icon0209, label: '주택재개발'},
      {icon: Icon0210, label: '재정비촉진지구'},
    ],
  },
  {
    id: '용도',
    content: [
      {icon: Icon0301, label: '전용주거지역'},
      {icon: Icon0302, label: '일반주거지역'},
      {icon: Icon0303, label: '준주거지역'},
      {icon: Icon0304, label: '상업지역'},
      {icon: Icon0305, label: '중심상업지역'},
      {icon: Icon0306, label: '공업지역'},
      {icon: Icon0307, label: '녹지지역'},
      {icon: Icon0308, label: '관리지역'},
      {icon: Icon0309, label: '농림지역'},
      {icon: Icon0310, label: '자연환경보전지역'},
    ],
  },
  {
    id: '도로·철도',
    content: [
      {icon: Icon0401, label: '장기계획도로'},
      {icon: Icon0402, label: '예정고속도로'},
      {icon: Icon0403, label: '공사중고속도로1'},
      {icon: Icon0404, label: '공사중고속도로2'},
      {icon: Icon0405, label: '예정·공사중국도'},
      {icon: Icon0406, label: '예정·공사중지방도'},
      {icon: Icon0407, label: '예정·공사중일반도로'},
      {icon: Icon0408, label: '예정철도'},
      {icon: Icon0409, label: '공사중철도'},
      {icon: Icon0410, label: '공사중지하철'},
    ],
  },
  {
    id: '국토계획',
    content: [
      {icon: Icon0501},
      {icon: Icon0502},
      {icon: Icon0503},
      {icon: Icon0504},
      {icon: Icon0505},
      {icon: Icon0506},
      {icon: Icon0507},
      {icon: Icon0508, label: '백두대간'},
      {icon: Icon0509, label: '4대강'},
      {icon: Icon0510, label: '수자원보존구역'},
    ],
  },
];

export const CadastralLegend = ({onClose, ...props}: IProps) => {
  const [activeTab, setActiveTab] = useState<ITab>(TABS[0]);

  return (
    <Root {...props}>
      <Body>
        <Tabs>
          {TABS.map((i) => (
            <Tab
              key={i.id}
              wide={i.id.length > 2}
              active={activeTab?.id === i.id}
              variant="medium12"
              onClick={() => setActiveTab(i)}
            >
              {i.id}
            </Tab>
          ))}
        </Tabs>
        {!!activeTab && <Items items={activeTab.content} />}
      </Body>
    </Root>
  );
};

const Items = ({
  items,
}: {
  items: Array<{
    icon?: string;
    label?: string;
  }>;
}) => {
  if (!items?.length) {
    return null;
  }

  const blockSize = Math.ceil(items.length / 2);
  const blocks = chunk(items, blockSize);

  return (
    <Content>
      {blocks.map((block, blockIdx) => (
        <Block key={`block-${blockIdx}`}>
          {block.map((i, itemIdx) => (
            <Item key={`item-${itemIdx}`}>
              {!!i.icon?.length && (
                <img src={i.icon} width="auto" alt={i.label} />
              )}
              {!!i.label?.length && (
                <Typography variant="medium12" as="div">
                  {i.label}
                </Typography>
              )}
            </Item>
          ))}
        </Block>
      ))}
    </Content>
  );
};

const Root = styled('div')`
  width: 383px;
  background-color: ${palette.white};
  border-radius: 5px;
  border: solid 1px ${palette.gray300};
  color: ${palette.textSecondary};
`;

const Body = styled.div``;

const Content = styled.div`
  display: flex;
  align-content: flex-start;
  padding: 16px;
  gap: 24px;
`;

const Block = styled.div`
  width: 50%;
  flex-grow: 1;
  flex-basis: 0;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const Item = styled.div`
  flex-grow: 1;
  flex-shrink: 0;
  height: 24px;
  display: flex;
  align-items: center;
  & > img {
    margin-right: 4px;
    height: 24px;
  }
`;

const Tabs = styled(Flexbox)`
  height: 42px;
  border-bottom: 1px solid ${palette.gray200};
`;

const Tab = styled(Typography)
  .withConfig({
    shouldForwardProp: interceptProps(['active', 'wide']),
  })
  .attrs({
    as: 'div',
  })<{
  active?: boolean;
  wide?: boolean;
}>`
  display: flex;
  flex-basis: 0;
  align-items: center;
  justify-content: center;
  padding: 12px 16px;
  cursor: pointer;
  white-space: nowrap;
  border-bottom: solid 2px transparent;
  ${({active}) =>
    active &&
    `
    font-weight: 700;
  `}
  ${({wide}) => `flex-grow: ${wide ? 2 : 1};`}
  color: ${palette.placeholder};
  ${({active}) =>
    active &&
    `
    color: ${palette.textPrimary};
    border-color: ${palette.textPrimary};
  `}
`;
